<script>
import { Line, mixins } from "vue-chartjs";
const { reactiveProp } = mixins;

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    title: {
      type: String,
      default: "",
    },
    options: {
      type: Object,
      default() {
        return { responsive: true, maintainAspectRatio: false };
      },
    },
    chartData: {
      type: Object,
      default: null,
    },
  },
  watch: {
    chartData() {
      this.$data._chart.update();
    },
  },
  mounted() {
    this.renderChart(this.chartData, {
      ...this.options,
      ...{
        title: {
          display: true,
          text: this.title,
        },
      },
    });
  },
};
</script>

<style lang="scss" scoped></style>
